import {
    ref, watch, type Ref,
} from 'vue';

export function useLastRegistration(currentEpcs: Ref<string[]>) {
    const lastRegisteredCount = ref<number | null>(null);
    let registeredEpcs = new Set<string>();

    // Remember the count together with the tags present at registration time
    const setLastRegistration = (count: number): void => {
        registeredEpcs = new Set(currentEpcs.value);
        lastRegisteredCount.value = count;
    };

    const clearLastRegistration = (): void => {
        registeredEpcs = new Set();
        lastRegisteredCount.value = null;
    };

    // Hide the notice once a tag that was not part of the last registration shows up
    watch(currentEpcs, epcs => {
        if (lastRegisteredCount.value !== null && epcs.some(epc => !registeredEpcs.has(epc))) {
            clearLastRegistration();
        }
    });

    return { lastRegisteredCount, setLastRegistration, clearLastRegistration };
}
